import * as React from 'react'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import MonthPicker from 'modules/core/components/MonthPicker'
import i18n from 'modules/core/lib/i18n'

import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
}

const ExportMonthSelector = ({ form }: Props) => {
  const handleStartDateChange = (value: string) => {
    form.get('from').set(value)
  }
  const handleEndDateChange = (value: string) => {
    form.get('to').set(value)
  }

  return (
    <>
      <FormRow multi>
        <MonthPicker
          label={i18n.t('common.starting_from')}
          value={form.get('from').value}
          placeholder={i18n.t('common.starting_from')}
          onChange={(value: string) => handleStartDateChange(value)}
        />
        <MonthPicker
          label={i18n.t('common.ending_at')}
          value={form.get('to').value}
          placeholder={i18n.t('common.ending_at')}
          onChange={(value: string) => handleEndDateChange(value)}
        />
      </FormRow>
    </>
  )
}

export default observer(ExportMonthSelector)
